// "Undecided" (not_viewed/error) renders as a labelled amber pill; the other
// statuses render as a plain coloured icon. Interactive classes are only
// applied when the pill sits inside a clickable control.
export const undecidedPillClasses =
  'flex min-h-8 items-center justify-center gap-1.5 rounded-full border border-amber-500 bg-amber-50 px-3 py-1.5 font-medium text-amber-700 text-xs';
export const undecidedPillInteractiveClasses = 'hover:bg-amber-100 hover:shadow-sm active:scale-95';

export const decidedPillClasses = 'h-7 w-7 rounded-full p-1.5';
// showLabel: the decided icon with its label beside it.
export const decidedLabelledPillClasses =
  'flex min-h-8 items-center gap-1.5 rounded-full px-2 py-1 font-medium text-muted-foreground text-xs';
export const decidedLabelledIconClasses = 'h-4 w-4';
export const decidedLabelledPillInteractiveClasses = 'transition-colors duration-150 hover:bg-muted';
export const decidedPillInteractiveClasses =
  'transition-transform duration-150 hover:scale-110 hover:bg-muted hover:shadow-sm group-hover:drop-shadow-sm active:scale-95';
